import React, { lazy, Suspense } from "react";
import { connect } from "react-redux";
import { Switch, Redirect, withRouter } from "react-router-dom";
import Loading from "components/shared-components/Loading";
import PrivateRoute from "./../../components/util-components/PrivateRoute";

const CategoryView = lazy(() => import(`./categories`));
const BranchView = lazy(() => import("./branch"));
const UsersView = lazy(() => import("./users"));
const PricesView = lazy(() => import("./prices"));
const VehiclesView = lazy(() => import("./vehicles"));
const TransactionsView = lazy(() => import("./transactions"));
const GroupsView = lazy(() => import("./groups"));
const ContractsView = lazy(() => import("./contracts"));
const NewContractView = lazy(() => import("./contracts-add"));
const DetailsContractView = lazy(() => import("./contracts-details"));
const DetailsGroupView = lazy(() => import("./groups-details"));
const UserProfileView = lazy(() => import("./profile"));
const ReportsView = lazy(() => import("./reports"));
const RolesView = lazy(() => import("./roles"));
const RolesEdit = lazy(() => import("./roles-edit"));
const InstructorsView = lazy(() => import("./instructors"));
const LessonTimesView = lazy(() => import("./lesson-times"));

export const AppViews = ({ match, homePage }) => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <PrivateRoute path={`${match.url}/branch`} component={BranchView} />
        <PrivateRoute path={`${match.url}/user-profile`} component={UserProfileView} />
        <PrivateRoute path={`${match.url}/categories`} component={CategoryView} />
        <PrivateRoute path={`${match.url}/users`} component={UsersView} />
        <PrivateRoute path={`${match.url}/prices`} component={PricesView} />
        <PrivateRoute path={`${match.url}/garage`} component={VehiclesView} />
        <PrivateRoute path={`${match.url}/transactions`} component={TransactionsView} />
        <PrivateRoute exact path={`${match.url}/groups`} component={GroupsView} />
        <PrivateRoute exact path={`${match.url}/contracts`} component={ContractsView} />
        <PrivateRoute exact path={`${match.url}/groups/add-contract`} component={NewContractView} />
        <PrivateRoute
          exact
          path={`${match.url}/groups/details-contract/:id`}
          component={DetailsContractView}
        />
        <PrivateRoute exact path={`${match.url}/groups/details/:id`} component={DetailsGroupView} />
        <PrivateRoute path={`${match.url}/reports`} component={ReportsView} />
        <PrivateRoute exact path={`${match.url}/roles`} component={RolesView} />
        <PrivateRoute exact path={`${match.url}/instructors`} component={InstructorsView} />
        <PrivateRoute exact path={`${match.url}/lesson-times`} component={LessonTimesView} />
        <PrivateRoute exact path={`${match.url}/roles/edit/:id`} component={RolesEdit} />
        <PrivateRoute exact path={`${match.url}/roles/add-role`} component={RolesEdit} />
        <Redirect from={`${match.url}`} to={homePage} />
      </Switch>
    </Suspense>
  );
};

const mapStateToProps = ({ auth: { homePage } }) => ({
  homePage,
});

export default connect(mapStateToProps, {})(withRouter(AppViews));
